import React from 'react';
import { APP } from '../config/app';
import { useLanguage } from '../i18n/LanguageContext';

const external = { target: '_blank', rel: 'noopener noreferrer' };

export function LegalInline({ className = '' }) {
  const { t } = useLanguage();
  return (
    <p className={`legal-text${className ? ` ${className}` : ''}`}>
      {t('legal.termsPrefix')}{' '}
      <a href={APP.termsUrl} {...external}>{t('legal.terms')}</a>
      {t('legal.termsAnd')}
      <a href={APP.privacyUrl} {...external}>{t('legal.privacy')}</a>
    </p>
  );
}

export function LegalRowLinks() {
  const { t } = useLanguage();
  return (
    <nav className="legal-row" aria-label={t('legal.section')}>
      <a href={APP.privacyUrl} className="legal-row__link" {...external}>
        {t('legal.privacy')}
      </a>
      <span className="legal-row__sep" aria-hidden>·</span>
      <a href={APP.termsUrl} className="legal-row__link" {...external}>
        {t('legal.terms')}
      </a>
    </nav>
  );
}
